/* RESPONSIBLE TEAM: team-omni */
import Model, { attr } from '@ember-data/model';

export default class DiscordIntegrationModel extends Model {
  @attr('string') declare discord_team_name: string;
}
